export default __webpack_public_path__ + "static/media/agreement-for-website.a27e711b.pdf";